export default {
    data() {
        return {
            initial_pagination_finished: false,
            pagination_failed: false,
            pagination: {},
            currently_paginating: false,
            pagination_settings: {
                infinite_scroll: true,
                paginate_on_mount: true,
                paginate_until_scrollable: false,
                minimum_pagination_items: 0,
            },
        }
    },

    computed: {
        lastPage() {
            if (this.pagination.current_page) {
                if (this.pagination.current_page < (this.pagination.last_page || this.pagination.total_pages)) {
                    return false;
                }
            }

            return true;
        },
    },

    destroyed() {
        if (this.pagination_settings.infinite_scroll) {
            window.removeEventListener('scroll', this.handleScroll);
        }
    },

    created() {
        if (this.pagination_settings.infinite_scroll) {
            window.addEventListener('scroll', this.handleScroll);
        }
    },

    mounted() {
        if (this.pagination_settings.paginate_on_mount) {
            this.startPagination();
        }
    },

    methods: {
        handleScroll() {
            //see if scrolled near bottom
            if ((window.innerHeight + window.pageYOffset + 1000) >= document.body.offsetHeight && this.paginationItemsLength > 0 && !this.pagination_failed) {
                if (!this.initial_pagination_finished || (this.pagination.current_page < (this.pagination.total_pages ? this.pagination.total_pages : this.pagination.last_page) && !this.currently_paginating)) {
                    // this.currently_paginating = true;

                    // setTimeout(() => {
                        this.startPagination();
                    // }, 100);
                }
            }
        },

        startPagination(reset = false) {
            if (reset) {
                this.currently_paginating = false;
                this.pagination = {};
                this.pagination_failed = false;
                this.initial_pagination_finished = false;
            }

            if (!this.currently_paginating) {
                this.currently_paginating = true;

                this.paginate(reset).then((response) => {
                    this.pagination = response.data.meta.pagination ? response.data.meta.pagination : response.data.meta;
                    const last_page = this.pagination.last_page ? this.pagination.last_page : this.pagination.total_pages;

                    if (typeof this.paginationCallback !== 'undefined') {
                        this.paginationCallback(response);
                    }

                    this.initial_pagination_finished = true;
                    this.currently_paginating = false;

                    this.$nextTick(() => {
                        if (this.pagination_settings.paginate_until_scrollable && (this.pagination.total > this.paginationItemsLength) && (last_page > this.pagination.current_page) && ((document.body.clientHeight < document.documentElement.clientHeight) || this.paginationItemsLength < this.pagination_settings.minimum_pagination_items)) {
                            this.startPagination();
                        }
                    });
                }).catch((err) => {
                    this.pagination_failed = true;
                });
            }
        }
    }
}
